import type { InputHTMLAttributes, Ref } from "react";
import "./text-field.css";

type Props = Omit<InputHTMLAttributes<HTMLInputElement>, "id" | "aria-invalid" | "aria-describedby"> & {
  id: string;
  label: string;
  /** Una spiegazione che resta scritta sotto il campo e legata al campo, come in Select. */
  hint?: string;
  error?: string;
  className?: string;
  /** Arriva all'`<input>` (in React 19 `ref` è una prop), per spostare il focus dopo un errore. */
  ref?: Ref<HTMLInputElement>;
};

// La classe base e la semantica di errore (aria-invalid, aria-describedby) sono
// di proprietà del componente: le prop native non possono sovrascriverle.
export function TextField({ id, label, hint, error, className, ...rest }: Props) {
  const hintId = `${id}-hint`;
  const errorId = `${id}-error`;
  const describedBy = [hint ? hintId : null, error ? errorId : null].filter(Boolean).join(" ");
  const classes = className ? `g-field__input ${className}` : "g-field__input";
  return (
    <div className="g-field">
      <label className="g-field__label" htmlFor={id}>{label}</label>
      <input
        id={id}
        {...rest}
        className={classes}
        aria-invalid={error ? "true" : undefined}
        aria-describedby={describedBy || undefined}
      />
      {hint ? <p id={hintId} className="g-field__hint">{hint}</p> : null}
      {error ? <p id={errorId} className="g-field__error" role="alert">{error}</p> : null}
    </div>
  );
}
